import { useLayoutEffect } from "react";
import { Icon } from "./Icon";
import { useSupabaseAuth } from "../../supabase/SupabaseContext";

/** Height of the bar's content row, excluding the status-bar inset. */
const BAR_HEIGHT = 34;

/**
 * A fixed bar across the top while an admin is previewing the app as a plain
 * member, with the way out built into it — the Admin tab disappears in this
 * mode, so without this the only exit would be the profile page.
 *
 * Rather than floating over the page it drives `--view-as-offset`, which every
 * screen's top inset already adds in, so the bar reserves real space instead
 * of covering whatever sits under it.
 */
const ViewAsBanner = () => {
  const { isViewingAsMember, setViewingAsMember } = useSupabaseAuth();

  // Layout effect, not effect: the mode is restored from sessionStorage
  // during render, so setting the offset after paint would flash a frame
  // of un-inset content under the bar on every reload.
  useLayoutEffect(() => {
    const root = document.documentElement;
    root.style.setProperty("--view-as-offset", isViewingAsMember ? `${BAR_HEIGHT}px` : "0px");
    return () => root.style.setProperty("--view-as-offset", "0px");
  }, [isViewingAsMember]);

  if (!isViewingAsMember) return null;

  return (
    <div
      className="fixed top-0 inset-x-0 z-50 bg-clay text-paper"
      style={{ paddingTop: "env(safe-area-inset-top)" }}
    >
      <div
        className="mx-auto max-w-md px-5 flex items-center justify-between gap-3"
        style={{ height: BAR_HEIGHT }}
      >
        <span className="font-mono text-[10px] tracking-[1.4px] uppercase flex items-center gap-2 min-w-0">
          <Icon name="user" variant="regular" size={11} className="flex-shrink-0" />
          <span className="truncate">Vist som menigt medlem</span>
        </span>
        <button
          onClick={() => setViewingAsMember(false)}
          className="font-mono text-[10px] tracking-[1.4px] uppercase font-bold underline underline-offset-2 flex-shrink-0"
        >
          Afslut
        </button>
      </div>
    </div>
  );
};

export default ViewAsBanner;
